import React from 'react'
import { useTranslation } from 'react-i18next'

import { RowItemTypes } from './types'
import { BaseText, BaseView } from '@/components/base'

export const RowItem: React.FC<RowItemTypes> = ({
  label,
  value,
  secondaryValue,
  labelProps,
  valueProps,
  skeletonActive = false,
  showSeparator = false,
  separatorGap = 8,
  IconComponent,
  isCopyable,
  copyValue,
  valueOnClick,
}) => {
  const { t } = useTranslation()

  return (
    <BaseView gap={separatorGap}>
      <BaseView
        row
        style={{
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <BaseView row align="center" gap={6}>
          <BaseText
            skeletonActive={skeletonActive}
            skeletonWidth={120}
            color="label.description"
            {...labelProps}
          >
            {t(label as any) || label}
          </BaseText>
        </BaseView>

        <BaseView
          row
          align="center"
          pl={8}
          gap={8}
          style={{ flex: 1, justifyContent: 'flex-end' }}
        >
          <BaseView
            gap={6}
            style={{ alignItems: 'flex-end', maxWidth: '224px' }}
          >
            <BaseText
              fontFamily="semibold"
              skeletonActive={skeletonActive}
              skeletonWidth={80}
              onClick={valueOnClick}
              style={{
                textAlign: 'right',
                wordBreak: 'break-word',
                ...valueProps?.style,
              }}
              {...valueProps}
            >
              {value}
            </BaseText>
            {!!secondaryValue && (
              <BaseText
                color="label.description"
                fontSize={14}
                style={{ textAlign: 'right' }}
              >
                {secondaryValue}
              </BaseText>
            )}
          </BaseView>

          {/* Иконка теперь справа от значения */}
          {!!IconComponent && !skeletonActive && <>{IconComponent}</>}

          {isCopyable && (
            <button
              onClick={() => {
                navigator.clipboard.writeText(copyValue || value)
                // TODO: Добавить toast уведомление
              }}
              className="p-1 hover:bg-gray-100 rounded"
            >
              📋
            </button>
          )}
        </BaseView>
      </BaseView>

      {showSeparator && (
        <BaseView
          style={{
            height: '2px',
            width: '100%',
            backgroundColor: 'var(--background-textInput)',
          }}
        />
      )}
    </BaseView>
  )
}

export default RowItem
